// eslint-disable-next-line no-restricted-imports
import { MemberResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';
import { client } from '@trello/graphql';
import {
  LoadMemberProfileDocument,
  LoadMemberProfileQuery,
  LoadMemberProfileQueryVariables,
} from './LoadMemberProfileQuery.generated';
import {
  LoadMemberNonPublicFieldsDocument,
  LoadMemberNonPublicFieldsQuery,
  LoadMemberNonPublicFieldsQueryVariables,
} from './LoadMemberNonPublicFieldsQuery.generated';
import { featureFlagClient } from '@trello/feature-flag-client';

// Action types
export const LOAD_MEMBER_REQUEST = Symbol('loaders/LOAD_MEMBER_REQUEST');
export const LOAD_MEMBER_SUCCESS = Symbol('loaders/LOAD_MEMBER_SUCCESS');

export type LoadMemberRequestAction = Action<
  typeof LOAD_MEMBER_REQUEST,
  string
>;
export type LoadMemberSuccessAction = Action<
  typeof LOAD_MEMBER_SUCCESS,
  MemberResponse
>;

// Action creators
const loadMemberRequest = actionCreator<LoadMemberRequestAction>(
  LOAD_MEMBER_REQUEST,
);
export const loadMemberSuccess = actionCreator<LoadMemberSuccessAction>(
  LOAD_MEMBER_SUCCESS,
);

export const loadMemberProfile = (
  idMemberOrUsername: string,
): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    dispatch(loadMemberRequest(idMemberOrUsername));
    const { data, error } = await client.query<
      LoadMemberProfileQuery,
      LoadMemberProfileQueryVariables
    >({
      query: LoadMemberProfileDocument,
      variables: {
        id: idMemberOrUsername,
      },
      context: {
        operationName: 'LoadMemberProfile',
        document: LoadMemberProfileDocument,
      },
      fetchPolicy: featureFlagClient.get('fep.use-cache-for-loaders', false)
        ? 'cache-first'
        : 'network-only',
    });
    const member = data.member;
    if (error || !member) {
      return;
    }

    dispatch(loadMemberSuccess(member));
  };
};

export const loadMemberNonPublicFields = (
  idMemberOrUsername: string,
): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    dispatch(loadMemberRequest(idMemberOrUsername));
    const { data, error } = await client.query<
      LoadMemberNonPublicFieldsQuery,
      LoadMemberNonPublicFieldsQueryVariables
    >({
      query: LoadMemberNonPublicFieldsDocument,
      variables: {
        id: idMemberOrUsername,
      },
      context: {
        operationName: 'LoadMemberNonPublicFields',
        document: LoadMemberNonPublicFieldsDocument,
      },
      fetchPolicy: featureFlagClient.get('fep.use-cache-for-loaders', false)
        ? 'cache-first'
        : 'network-only',
    });
    const member = data.member;
    if (error || !member) {
      return;
    }

    dispatch(loadMemberSuccess(member));
  };
};
